export default {
  '_b._qhyy': '切换语言',

  '_a._jzz': '加载中...',
  '_a._jzgd': '加载更多',
  '_a._wct': '欢迎来到',
  '_a._gd': '更多',
  '_a._bf': '播放',
  '_a._bcz': '保存中...',
  '_a._sctp': '上传图片',

  '_dl._qssyx': '请输入邮箱',
  '_dl._qssmm': '请输入密码',
  '_dl._ann': '登录',
  '_dl._hmyzh': '你没有账号?',
  '_dl._qzc': '去注册',
  '_dl._yzhl': '你有账号?',
  '_dl._qdl': '去登录',
  '_dl._srqrmm': '请输入确认密码',
  '_dl._sryqm': '请输入邀请码',
  '_dl._sryzm': '请输入验证码',
  '_dl._ljzc': '立即注册',
  '_dl._zcbsty': '注册则表示已阅读并同意',
  '_dl._yszc': '《隐私政策》',
  '_dl._lcmmbyy': '两次输入的密码不一致',

  '_yzm._fsyzm': '發送驗證碼',
  '_yzm._cxfs': '({time}) 重發',
  '_yzm._fsz': '发送中...',
  '_yzm._fscg': '發送成功',

  '_h._zrm': '最热门',
  '_h._zxd': '最新的',
  '_h._phb': '排行',
  '_h._qz': '墙纸',
  '_h._ssww': '搜索',
  '_h._lsjl': '历史记录',
  '_h._gd': '更多',
  '_h._dl': '登录',
  '_h._ye': '余额',
  '_h._dj': '冻结',
  '_h._ybp': '仪表盘',
  '_h._wdqb': '我的钱包',
  '_h._scjl': '收藏记录',
  '_h._xxzx': '消息中心',
  '_h._fxhy': '分享好友',
  '_h._bzzx': '帮助中心',
  '_h._ggtf': '广告投放',
  '_h._bqtz': '版权投资',
  '_h._sz': '设置',

  '_sy._jx': '精选',
  '_sy._xpfb': '新品发布',
  '_sy._gdsp': '更多视频',

  '_qz._jbqz': '精美墙纸收藏',
  '_qz._ssqz': '搜索墙纸',
  '_qz._qb': '全部',
  '_qz._zrfg': '自然风光',
  '_qz._cxys': '抽象艺术',
  '_qz._csjz': '城市建筑',
  '_qz._dmyx': '动漫游戏',
  '_qz._yzxk': '宇宙星空',
  '_qz._yl': '预览',
  '_qz._xzqz': '下载墙纸',
  '_qz._fbl': '分辨率',
  '_qz._fl': '分类',
  '_qz._jzz': '加载中',
  '_qz._myzdpp': '没有找到匹配的墙纸',

  '_sp._xyjscl': '需要解锁才能观看',
  '_sp._cz': '充值',
  '_sp._jsqj': '解锁全集',
  '_sp._jsbj': '解锁本集',
  '_sp._sc': '收藏',
  '_sp._fx': '分享',
  '_sp._jsqjjs': '确认支付{a}并解锁全集吗?',
  '_sp._jsbjjs': '确认支付{a}并解锁全集吗?',
  '_sp._zfz': '支付中...',
  '_sp._qrzf': '确认支付',
  '_sp._qx': '取消',

  '_qz._smrc': '山脉日出',
  '_qz._cxjh': '抽象几何',
  '_qz._dsyj': '都市夜景',
  '_qz._dmfj': '动漫风景',
  '_qz._hhxk': '浩瀚星空',
  '_qz._slmw': '森林迷雾',
  '_qz._scld': '色彩流动',
  '_qz._xdjz': '现代建筑',

  '_qb._cbjl': '存币记录',
  '_qb._jyjl': '交易记录',
  '_qb._bddz': '绑定地址',
  '_qb._txjl': '提现记录',

  '_m._tcdl': '退出登录',
  '_m._cb': '存币',
  '_m._tb': '提币',

  '_cb._ssdz': '搜索币种或地址',
  '_cb._bz': '币种',
  '_cb._je': '金额',
  '_cb._dz': '地址',
  '_cb._sj': '时间',
  '_cb._cz': '操作',
  '_cb._zwjl': '暂无交易记录',
  '_cb._dny': '第{a}页,共{b}页',
  '_cb._jyxq': '交易详情',
  '_cb._jydz': '交易地址',
  '_cb._zt': '状态',
  '_cb._yqr': '已确认',
  '_cb._qb': '全部',
  '_cb._jt': '今天',
  '_cb._j7t': '近7天',
  '_cb._j30t': '近30天',
  '_cb._zw': '暂无',
  '_cb._fzcg': '地址已复制到剪贴板',

  '_jyjl._ssdz': '搜索币种或地址',
  '_jyjl._lx': '类型',
  '_jyjl._je': '金额',
  '_jyjl._ye': '余额',
  '_jyjl._dj': '冻结',
  '_jyjl._sj': '时间',
  '_jyjl._cz': '操作',
  '_jyjl._zwjyjl': '暂无交易记录',
  '_jyjl._czsx': '重置筛选',
  '_jyjl._dny': '第{a}页,共{b}页',
  '_jyjl._jyxq': '交易详情',
  '_jyjl._jylx': '交易类型',
  '_jyjl._jyje': '交易金额',
  '_jyjl._jyhye': '交易后余额',
  '_jyjl._djye': '冻结金额',
  '_jyjl._jysj': '交易时间',
  '_jyjl._jyzt': '交易状态',
  '_jyjl._ywc': '已完成',
  '_jyjl._qb': '全部',
  '_jyjl._jt': '今天',
  '_jyjl._j7t': '近7天',
  '_jyjl._j30t': '近30天',

  '_jyjl._tp1': '存币',
  '_jyjl._tp2': '提币',
  '_jyjl._tp3': '支付',
  '_jyjl._tp4': '存币',
  '_jyjl._tp5': '冻结',
  '_jyjl._tp6': '收益',
  '_jyjl._tp7': '邀请奖励',
  '_jyjl._tp8': '登录奖励',
  '_jyjl._tp9': '推广收益',
  '_jyjl._tp10': '看视频奖励',
  '_jyjl._tp11': '注册礼金',
  '_jyjl._tp12': '提现驳回',
  '_jyjl._tp13': '消息红包',
  '_jyjl._tp14': '内部划转',

  '_cb._shz': '审核中',
  '_cb._yyg': '已通过',
  '_cb._ybh': '已驳回',

  '_bddz._tjdz': '添加地址',
  '_bddz._ssdz': '搜索地址',
  '_bddz._bz': '币种',
  '_bddz._dz': '地址',
  '_bddz._sysj': '使用时间',
  '_bddz._cz': '操作',
  '_bddz._zwjl': '暂无地址记录',
  '_bddz._dny': '第{a}页,共{b}页',
  '_bddz._dzewm': '地址二维码',
  '_bddz._fzdz': '复制地址',
  '_bddz._dzxq': '地址详情',
  '_bddz._wl': '网络',
  '_bddz._tjsj': '添加时间',
  '_bddz._bzwa': '备注',
  '_bddz._ntq': '{a}天前',
  '_bddz._nxsq': '{a}小时前',
  '_bddz._nfzq': '{a}分钟前',
  '_bddz._ngg': '刚刚',
  '_bddz._dzyfz': '地址已复制到剪贴板',
  '_bddz._scqr': '删除确认',
  '_bddz._scqrdz': '确定要删除这个地址吗？',
  '_bddz._qr': '确定',
  '_bddz._qx': '取消',
  '_bddz._scdzcg': '地址删除成功',

  '_txjl._ztsx': '状态筛选',
  '_txjl._qbzt': '全部状态',
  '_txjl._shz': '审核中',
  '_txjl._ytg': '已通过',
  '_txjl._yjj': '已拒绝',
  '_txjl._ssdz': '搜索地址或金额',
  '_txjl._bz': '币种',
  '_txjl._je': '金额',
  '_txjl._dz': '地址',
  '_txjl._zt': '状态',
  '_txjl._sj': '时间',
  '_txjl._cz': '操作',
  '_txjl._zwjl': '暂无交易记录',
  '_txjl._czsx': '重置筛选',
  '_txjl._dny': '第{a}页,共{b}页',
  '_txjl._jyxq': '交易详情',
  '_txjl._skdz': '收款地址',
  '_txjl._jysj': '交易时间',
  '_txjl._jyzt': '交易状态',
  '_txjl._fzdz': '地址已复制到剪贴板',

  '_cbsq._bz': '币种',
  '_cbsq._wl': '网络',
  '_cbsq._erwm': '二维码',
  '_cbsq._fzdz': '复制地址',

  '_txsq._bz': '币种',
  '_txsq._wl': '网络',
  '_txsq._ye': '余额',
  '_txsq._sxf': '手续费',
  '_txsq._zxtx': '最小提现',
  '_txsq._txdz': '提现地址',
  '_txsq._qxztxdz': '请选择提现地址',
  '_txsq._txje': '提现金额',
  '_txsq._qsrtxje': '请输入提现金额',
  '_txsq._yxyzm': '邮箱验证码',
  '_txsq._qsryxyzm': '请输入验证码',
  '_txsq._ljtx': '立即提现',

  '_jl._wxhd': '我喜欢的',
  '_jl._lsjl': '历史记录',

  '_xx._bt': '消息中心',
  '_xx._wjl': '无记录',
  '_xx._zsmyxx': '暂时没有消息',
  '_xx._sxxx': '刷新消息',
  '_xx._sxcg': '刷新成功',

  '_fx._fxhy': '分享好友',
  '_fx._smfx': '扫描二维码分享给好友',
  '_fx._jlsm': '奖励说明',
  '_fx._jlsm1': '1.您直接邀請的朋友，簡稱1級，您將獲得他收益的{a}%',
  '_fx._jlsm2': '2.您的1級朋友，若他再邀請朋友，簡稱2級，獲得他收益的{a}%',
  '_fx._jlsm3': '3.您的2級朋友，若他再邀請朋友，簡稱3級，獲得他收益的{a}%',
  '_fx._fzlj': '复制链接',

  '_bzzx._bzzx': '帮助中心',
  '_bzzx._rhzczh': '如何注册账户',
  '_bzzx._zclc': '注册流程',
  '_bzzx._rhzcxyh': '如何注册新账户？',
  '_bzzx._rhzcxyh1': '点击"注册"按钮，输入您的邮箱地址，设置密码，完成邮箱验证后即可成功注册账户。',
  '_bzzx._rhcz': '如何充值？',
  '_bzzx._rhcz1': '充值流程',
  '_bzzx._rhcz2': '充值详细说明',
  '_bzzx._rhcz3': '點擊我的錢包，存入，選擇你想存入的加密貨幣，向該地址存入即可',

  '_bzzx._rhjsdj': '如何解锁短剧',
  '_bzzx._rhjsdj2': '點擊單集解鎖劇情，看更多精彩內容',

  '_bzzx._rhtx': '账户如何提现',
  '_bzzx._rhtx1': '1.點選我的錢包，提領位址，新增對應加密貨幣提現位址<br>2.點選提現，選擇對應加密貨幣，選擇已綁定的地址，輸入提現數量,等待到帳即可',

  '_bzzx._qtwt': '其他问题',
  '_bzzx._qtwt1': '如何联系客服？',
  '_bzzx._qtwt2': '可通过网站右下角的在线客服、客服邮箱或客服热线联系我们。',
  '_bzzx._myzdwt': '没有找到您要的答案？',
  '_bzzx._khjybbzn': '我们的客服团队很乐意为您提供进一步的帮助。',
  '_bzzx._lxkf': '联系客服',

  '_ggtf._bt1': '广告投放',
  '_ggtf._splb': '视频列表',
  '_ggtf._wcyd': '我参与的',
  '_ggtf._hdbm': '活动编码',
  '_ggtf._tian': '天',
  '_ggtf._kssj': '开始时间',
  '_ggtf._jssj': '结束时间',
  '_ggtf._ddvp': '达到VIP{a}级，人均参与{b}次',
  '_ggtf._hdzt': '活动状态',
  '_ggtf._wks': '未开始',
  '_ggtf._ycy': '已参与',
  '_ggtf._qg': '抢购',
  '_ggtf._mygdl': '没有更多了',
  '_ggtf._qgrtd': '抢购人数太多,请重试',
  '_ggtf._hdxq': '活动详情',
  '_ggtf._hdjs': '活动介绍',
  '_ggtf._cyyq': '参与要求',
  '_ggtf._zdtz': '最低投资',
  '_ggtf._vpdj': 'VIP等级',
  '_ggtf._rjcy': '人均参与',
  '_ggtf._gmje': '购买金额',
  '_ggtf._qsrgmje': '请输入购买金额',
  '_ggtf._qx': '取消',
  '_ggtf._ljcy': '立即参与',
  '_ggtf._ssjymm': '输入交易密码',
  '_ggtf._qssjymm': '请输入交易密码',
  '_ggtf._ji': '级',
  '_ggtf._ci': '次',
  '_ggtf._zdgm': '最低购买金额',
  '_ggtf._zggm': '最高购买金额',
  '_ggtf._zfz': '支付中...',

  '_wdtg._wjl': '暂无参与记录',
  '_wdtg._tzje': '投资金额',
  '_wdtg._zsy': '总收益',
  '_wdtg._hdts': '活动天数',
  '_wdtg._cysj': '参与时间',
  '_wdtg._qzf': '去支付',
  '_wdtg._jxz': '进行中',
  '_wdtg._djszje': '待结算总金额',
  '_wdtg._gjb': '共{a}笔',
  '_wdtg._djs': '待结算',
  '_wdtg._zrsy': '昨日收益',
  '_wdtg._dbl': '点播量',
  '_wdtg._bfl': '播放量',
  '_wdtg._wdsy': '我的收益',
  '_wdtg._bqffc': '版权方分成',
  '_wdtg._mr0djs': '每日0点结算昨日收益',
  '_wdtg._jrsy': '今日收益',
  '_wdtg._mygd': '没有更多了',

  '_bqyy._bqyy': '版权合作申请预约',
  '_bqyy._qrbq': '确认版权合作预约申请？',
  '_bqyy._qx': '取消',
  '_bqyy._tjyy': '提交预约',

  '_bqyy._spsq': '视频版权合作申请预约',
  '_bqyy._spsy': '与版权商一起推广视频，让视频带来更多的流量，更多的收益！',
  '_bqyy._ljyy': '立即预约',
  '_bqyy._sphz': '什么是影片版权合作申请？',
  '_bqyy._sphzsm': '影片版权合作申请是提供影片更多推广合作共赢。透过申请，您将获得版权商的认可，并有机会与版权商进行深度合作，获得更多曝光和收益。',
  '_bqyy._sqhch': '申请版权合作的好处',
  '_bqyy._llfz': '流量扶持',
  '_bqyy._llfzsm': '获得平台推广机会，增加曝光和播放量',
  '_bqyy._sytg': '收益提升',
  '_bqyy._sytgsm': '获得更高的广告分成和商业合作机会',
  '_bqyy._yxhz': '优先合作',
  '_bqyy._yxhzsm': '优先参与平台官方活动与商业合作专案',
  '_bqyy._yytj': '预约条件',
  '_bqyy._sptg': '影片广告推广要求',
  '_bqyy._sptgsm': '至少参与1个影片推广达到平台标准',
  '_bqyy._yysm': '点击预约后，我们的工作人员将在3个工作天内与您联系',

  '_ybp._wdsy': '我的收益',
  '_ybp._dqye': '當前餘額',
  '_ybp._jr': '今日',
  '_ybp._jrzsy': '今日總收益',
  '_ybp._ljzsy': '累计總收益',
  '_ybp._tgfh': '推广分红',
  '_ybp._ljsy': '累計收益',
  '_ybp._bqsy': '版權收益',
  '_ybp._yqfh': '邀请分红',
  '_ybp._mrsy': '每日收益',
  '_ybp._tgsy': '推广收益',

  '_tjdz._tjxd': '添加新地址',
  '_tjdz._xzbz': '选择币种',
  '_tjdz._qbdz': '钱包地址',
  '_tjdz._srdz': '请输入钱包地址',
  '_tjdz._qx': '取消',
  '_tjdz._bc': '保存',

  '_sz._smrz': '實名認證',
  '_sz._rzlx': '认证类型',
  '_sz._sfzzm': '身份正面照',
  '_sz._sfzfm': '身份反面照',
  '_sz._zsxm': '真實姓名',
  '_sz._qsrzsxm': '請輸入真實姓名',
  '_sz._sfzhm': '身份證號碼',
  '_sz._qsrsfzhm': '請輸入身份證號碼',
  '_sz._yyzz': '营业执照',
  '_sz._qymc': '企业名称',
  '_sz._yyzzh': '营业执照号',
  '_sz._qsrqymc': '請輸入企业名称',
  '_sz._qsryyzzh': '請輸入营业执照号',
  '_sz._qx': '取消',
  '_sz._tjrz': '提交認證',
  '_sz._zt': '状态',
  '_sz._gr': '个人',
  '_sz._qy': '企业',
  '_sz._shz': '审核中',
  '_sz._ytg': '已通过',
  '_sz._ybh': '已驳回',

  '_mm._xgmm': '修改密碼',
  '_mm._dqxg': '定期修改密码保护账户安全',
  '_mm._dqmm': '當前密碼',
  '_mm._xmm': '新密碼',
  '_mm._qrxmm': '確認新密碼',
  '_mm._qx': '取消',
  '_mm._qrxg': '確認修改',

  '_jymm._xgjymm': '修改交易密碼',

  '_szzx._sz': '設定',
  '_szzx._yrz': '已認證',
  '_szzx._wrz': '未認證',
  '_szzx._jymm': '交易密碼',
  '_szzx._szjymm': '设置或修改交易密码',
  '_szzx._tcdl': '退出賬號',
  '_szzx._qdtcdl': '确定要退出登录账号吗?',
  '_szzx._qrtc': '确认退出',
  '_szzx._qx': '取消',

  '_yj._gy': '关于',
  '_yj._lxwm': '联系我们',
  '_yj._yszc': '隐私政策',
  '_yj._yhxy': '用户协议',

  '_cd._gszz': '公司资质',
  '_cd._wmyy': '我们拥有完整的行业资格和认证，为用户提供合法、安全、高品质的视讯服务',
  '_cd._yyzz': '公司合法经营的有效证明，展示了我们的正规注册资讯和经营范围',
  '_cd._yyzz2': '依法取得的公司认证营业执照，确保平台内容合法合规',
  '_bz._lxkf': '点击下方联系客服,客服信箱或客服专线联系我们',

  '_sz._bjtx': '编辑',
  '_sz._bjxx': '编辑信息',
  '_sz._tx': '头像',
  '_sz._bcun': '保存',

  '_db._zskf': '联系客服',
  '_db._zsry': '专属客服',
  '_db._wdq': '未读',
  '_db._ydq': '已读',

  '_sc._sctp': '上传图片',
  '_sc._xztp': '选择图片',
  '_sc._fstp': '发送图片',
  '_sc._qx': '取消',
  '_sc._hd': '好的',

  '_zcyl._zcbt': '注册有礼',
  '_zcyl._djdkhb': '点击打开红包',
  '_zcyl._zclj': '注册礼金',
  '_zcyl._hmyzh': '还没有账户?',
  '_zcyl._qzc': '去注册',
  '_zcyl._qxdjhb': '请先领取红包',
  '_zcyl._qwzc': '前往注册',
  '_zcyl._hbysy': '红包已经使用',

  '_ggtg._qhz': '去划转',
  '_ggtg._dqye': '当前余额',
  '_ggtg._qcz': '去充值',
  '_ggtg._hzje': '划转金额',
  '_ggtg._ljhz': '立即划转',
  '_ggtg._yebz': '余额不足',

  '_sq._bhbt': '已駁回',
  '_sq._bhyy': '駁回原因',

  '_xx._ntq': '{n}天前',
  '_xx._nxsq': '{n}小時前',
  '_xx._nfzq': '{n}分鐘前',
  '_xx._nggq': '剛剛',
  '_xx._djckgd': '點擊看更多',

  '_ct._zt': '状态',
  '_ct._ljz': '连接中',
  '_ct._ylj': '已连接',
  '_ct._ltlieb': '聊天列表',
  '_ct._bnhzj': '不能和自己聊天',
  '_ct._cylb': '成员列表',

  '_hb._fhb': '红包',
  '_hb._dqye': '当前余额',
  '_hb._fsd': '发送到',
  '_hb._hbje': '红包金额',
  '_hb._qshuru': '请输入红包金额',
  '_hb._ljfs': '立即发送',
  '_hb._hbz': '红包祝福语',
  '_hb._qshuruzhu': '请输入祝福语',

  '_sp._cuow': '需要先解锁1-10集才能观看',

  '_bq._tzzq': '投资周期',
  '_bq._zrsy': '昨日收益',
  '_bq._bqtz': '版权投资',
  '_bq._tzdj': '投资金额',
  '_bq._zfjz': '必须在24小时内支付，否则视为放弃!',
  '_bq._qzf': '去支付',
  '_bq.jz': '截止',
  '_bq._ljzf': '立即支付',
  '_bq._sqbz': '申请备注(可选)',
  '_bq._sqbzsm': '请输入申请备注',
  '_bq._zzsqz': '申请版权中,等待审核...',

  '_app._xz': '下载ReelShortBiz应用程序',
  '_app._smerm': '扫描二维码下载',
  '_app._xzbt': '下载APP',

  '_m._yhzz': '银行转账',
  '_m._yhxx': '银行信息',
  '_m._yhmz': '银行名称',
  '_m._yhdz': '银行地址',
  '_m._yhmc': '姓名',
  '_m._yhzh': '账号',
  '_m._yhlx': '类型',
  '_m._yhly': '路由',
  '_m._yhdm': '代码',
  '_m._yhbz': '备注',
  '_m._fzxx': '复制信息',

  '_m._zts': '提示',
  '_m._zyd1': '1.转账时请仔细核对收款人姓名、账号及银行代码，任一错误均可能导致汇款丢失',
  '_m._zyd2': '2.建议选择"汇款人承担全部费用",避免因中转行扣费导致收款金额不足',
  '_m._zyd3': '3.转账通常需1-3个工作日,请耐心等待,如有任何问题请联系客服',
  '_m._zyd4': '4.如果有其他问题，请联系客服',

  '_m._jyh': '交易号',
  '_m._jyje': '金额',

  '_sp._dbye': '点播余额',
  '_sp.hzye': '划转',
  '_sp._txje': '划转金额',
  '_sp._qsrtxje': '请输入划转金额',
  '_sp._ljhz': '立即划转',
  '_sp._yebz': '余额不足',
  '_sp._qshuru': '请输入正确的转账金额',
  '_sp._fanh': '返回',

  '_sp._tliu': '投流',
  '_sp._xzgj': '选择国家',
  '_sp._cdcw': '视频编码错误',
  '_ggtf._hot': '热门',
  '_tl._tlsj': '投流时间',
  '_tl._xzxb': '选择性别',
  '_tl._nan': '男',
  '_tl._nv': '女',
  '_tl._hunhe': '混合',
  '_tl._xznl': '选择年龄',
  '_sp._us': '美国',
  '_sp._en': '英国',
  '_sp._jp': '日本',
  '_sp._fr': '法国',
  '_sp._kr': '韩国',
  '_sp._de': '德国',
  '_sp._id': '印度',
  '_sp._in': '印尼',
  '_sp._au': '澳大利亚',
  '_sp._es': '西班牙',
  '_sp._my': '马来西亚',
  '_sp._cn': '中国',
  '_ggtf._fanhui': '返回',
  '_ggtf._jymmts': '请确认交易金额无误后输入密码',
  '_wdtg._wjl_desc': '您还没有参与任何广告投放活动',
  '_wd._jxz': '进行中',
  '_wd._djs': '待结算',
  '_wd._ywc': '已完成',
  '_wd._jz': '紧急',
  '_wd._hz': '划转',

  '_tl._tlfbqk': '投流资金分布情况',
  '_tl._tlfbqk_desc': '1-5天:5%(冷启动期)、6-10天:20%(内容验证期)、11-15天:40%(IP塑造期)、16-20:35%(短剧矩阵期)',

  '_nhz._sm': '转账后金额将转入视频钱包，用于解锁视频内容',
  '_nhz._zhzz': '转账中...',
  '_nhz._zzcg': '转账成功',
  '_nhz._zhzsb': '转账失败，请重试',
  '_m._fzcg': '复制成功',
  '_m._fzsb': '复制失败，请手动复制',
  '_m._zwfzxx': '暂无信息可复制',
  '_tx._qb': '全部',
  'activity.detail': '活动详情',
  'activity.noDesc': '暂无活动介绍',
  'activity.desc': '活动介绍',
  'activity.requirements': '参与要求',
  'activity.minInvest': '最低投资',
  'activity.vipLevel': 'VIP等级',
  'activity.avgParticipation': '人均参与',
  'activity.avgParticipationDesc': '次',
  'activity.country': '选择国家',
  'activity.deliveryTime': '投流时间',
  'activity.deliveryTimeDesc': '天',
  'activity.gender': '选择性别',
  'activity.male': '男',
  'activity.female': '女',
  'activity.mixed': '混合',
  'activity.age': '选择年龄',
  'activity.amount': '购买金额',
  'activity.back': '返回',
  'activity.join': '立即参与',
  emptyData: '暂无数据',
  emptyDataDesc: '暂无参与的广告活动',
  completedtlement: '已过时',
  preheat: '预热中',
  progress: '进行中',
  settlement: '待结算',
  transfered: '已划转',
  completed: '已完成',
  activityCode: '活动编码',
  touzAmount: '投资金额',
  activityDays: '活动天数',
  joinTime: '参与时间',
  playSource: '播放来源分布',
  allPlatforms: '全部平台',
  other: '其他',
  totalPlayNum: '总播放量',
  incomeSummary: '收益总结',
  totalPay: '支付版权费',
  totalIncome: '总收入',
  copyrightRatio: '版权方分成比例',
  promotionIncome: '推广收益',
  copyrightIncome: '版权分成',
  playNum: '播放量',
  buyNum: '点播量',
  incomeRate: '分成比例',
  yjIncome: '预估收入',
  paid: '已支付',
  timeout: '已超时',
  transfer: '立即划转',
  loading: '加载中...',
  loadMore: '加载更多',
  noMore: '没有更多了',
  nightTime: '凌晨时段',
  morningTime: '上午时段',
  afternoonTime: '下午时段',
  eveningTime: '晚间时段',
  '_h._tc': '注销',
  periodPayment: '时段支付',
  periodPaymentDesc: '每日分4个时段结算，您可按时段支付版权费用',

  day: '天',
  '_dl._hy': '欢迎回来',
  '_dl._cj': '创建账号',
  '_dl._zmm': '重置密码',
  '_dl._hyDesc': '登录您的账号，继续探索精彩内容',
  '_dl._cjDesc': '加入 ReelShortBiz，开启精彩之旅',
  '_dl._zmmDesc': '输入您的邮箱，我们将发送重置验证码',
  '_dl._hlgqsp': '海量高清影视资源',
  '_dl._gxhty': '个性化推荐算法',
  '_dl._ffddsp': '丰富的短视频',
  '_dl._dlzh': '登录账号',
  '_dl._sdndyx': '输入您的邮箱和密码继续',
  '_dl._email': '邮箱地址',
  '_dl._qsryx': '请输入您的邮箱地址',
  '_dl._dlmm': '密码',
  '_dl._qsrmm': '请输入您的密码',
  '_dl._wjmm': '忘记密码？',
  '_dl._immdl': '立即登录',
  '_dl._hmyzh2': '还没有账号？',
  '_dl._ljzc2': '立即注册',
  '_dl._cjzh': '创建账号',
  '_dl._jswmd': '加入 ReelShortBiz，开启精彩之旅',
  '_zh._qszmm': '请设置您的密码',
  '_zh._qrmm': '确认密码',
  '_zh._qmm': '请再次输入密码',
  '_zc._yqm': '邀请码',
  '_zc._sryqm': '请输入邀请码',
  '_dl._yzm': '验证码',
  '_dl._qsryzm': '请输入验证码',
  '_dl._yjyzh': '已有账号？',
  '_dl._zcbsty2': '注册即代表同意',
  '_dl._zcbstyDesc': '隐私政策',
  '_dl._newmm': '新密码',
  '_dl._qszxmm': '请设置新密码',
  '_dl._qrmm': '确认密码',
  '_dl._qzcsrmm': '请再次输入新密码',
  '_dl._czmm': '重置密码',
  '_dl._xqlmm': '想起了密码？',
  '_dl._fhdl': '返回登录',
  '_dl._srdllmmbyz': '两次密码输入不一致',
  '_dl._czcg': '密码重置成功',
  '_h._zc': '注册',
  // '_ybp._wdsy': '我的收益',
  '_ybp._jrsy': '今日收益',
  '_ybp._jztr': '较昨日',
  '_ybp._bfl': '播放量',
  '_ybp._dbl': '点播量',
  '_ybp._syqs': '收益趋势',
  // '_ybp._jr': '今日',
  '_ybp._t': '天',
  // '_ybp._dqye': '账户余额',
  '_ybp._djs': '待结算',
  '_ybp._zhl': '转化率',
  '_ybp._sjgl': '数据概览',
  '_ybp._zrsy': '昨日收益',
  '_ybp._bysy': '本月收益',
  '_ybp._yysj': '运营数据',
  '_ybp._zr': '昨日',
  '_ybp._zjfrs': '总付费人数',
  '_ybp._mtdqje': '明天到账金额',
  '_ybp._jsy': '净收益',
  '_ybp._bqfy': '版权费用支付计划',
  '_ybp._yzf': '已支付',
  '_ybp._qzf': '去支付',
  '_ybp._bqfyts': '版权费用支付后，将优先保障您的收益和权益。',
  '_ybp._syjl': '收益记录',
  '_ybp._ckgd': '查看更多',
  '_ybp._ssdt': '实时动态',
  '_ybp._bzzx': '帮助中心',
  '_ybp._lxkf': '联系客服',
  '_ybp._zrxz': '昨日收益',
  '_ybp._zdsy': '总收益',
  '_ybp._qygy': '上个月',
  '_ybp._jsjl': '结算记录',
  '_ybp._hzjl': '划转记录',
  '_ybp._jfzq': '分钟前',
  '_ybp._fzq': '小时前',
  '_ybp._djs_mt': '明日结算金额',
  '_yj._rule': '平台规则',

  '_bq._jjks': '立即开始',
  '_bq._jxz': '进行中',
  '_bq._jks': '距开始',
  '_bq._jjs': '距结束',
  '_bq._t': '天',
  '_bq._h': '时',
  '_bq._m': '分',
  '_bq._s': '秒',
  '_bq._kssj': '开始时间',
  '_bq._jssj': '结束时间',
  '_bqq._tzdj': '投资单价',
  '_bqq._hdts': '活动天数',
  '_bqq._vip': 'VIP级别',
  '_bqq._rjcy': '人均参与',
  '_bqq._cs': '次',
  '_bqq._ysjd': '已售进度',
  '_bqq._ljqg': '立即抢购',
  '_bqq._zbkqg': '暂不可购',
  '_bqq._jzz': '加载中',
  '_bqq._jzgd': '加载更多',
  '_bqq._wz': '没有更多了',

  '_sp._gdsj': '共{n}集',
  '_sy._jl': '待结算记录',
  '_ybp._zsy': '总收益',
  '_ybp._djsjl': '待结算记录',
  '_ybp._bqbm': '编码',
  '_ybp._je': '金额',
  '_ybp._sj': '时间',
  '_sy._djs': '待结算',
  '_sy._yjs': '已结算',
  '_sy._gdstjl': '共{n}条记录',
  '_sy._gjd': '共{n}条'
}
